import type { ReactNode } from 'react';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { useSplit } from 'src/shared/hooks';

const Feature = ({
  children,
  name,
  renderWithTreatment = 'on',
}: {
  children: ReactNode;
  name: string;
  renderWithTreatment?: string;
}) => {
  const [treatment, setTreatment] = useState<string | undefined>();
  const { client: clientPromise } = useSplit();

  useEffect(() => {
    void (async () => {
      const client = await clientPromise;

      setTreatment(client?.getTreatment(name));
    })();
  }, [clientPromise, name]);

  // render nothing until a treatment exists to prevent desync from server
  if (!treatment) return null;

  if (renderWithTreatment !== treatment) return null;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export { Feature };
